import ko from 'knockout';

// Knockout: Control descendant bindings.
ko.bindingHandlers.stopBinding = {
  init: () => ({
    controlsDescendantBindings: true,
  }),
};

ko.virtualElements.allowedBindings.stopBinding = true;
